import { useQuery } from "@tanstack/react-query";
import { getTargetareTinte } from "@/api/endpoints/targetareTinte";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareTinte() {
  return useQuery({
    queryKey: queryKeys.targetare.tinte(),
    queryFn: getTargetareTinte,
    select: (response) => response.data,
    staleTime: 1000 * 30,
    retry: 1,
  });
}
